import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
type Plan = {
  id: string;
  label: string;
  name: string;
  price: string;
  originalPrice?: string;
  oldValue?: string;
  priceNote: string;
  promoBadge?: string;
  description: string;
  items: string[];
  cta: {
    label: string;
    href: string;
  };
  urgency?: string;
  highlighted?: boolean;
  badge?: string;
};
const plan1: Plan = {
  id: 'plan-1',
  label: 'PLAN 1',
  name: 'Creación de Empresa en EE.UU.',
  price: '$250',
  priceNote: 'pago único · * no incluye fee del estado',
  description: 'Crea tu empresa en EE. UU. con claridad, estructura y acompañamiento desde el inicio.',
  items: ['LLC lista y activa', 'EIN listo para operar', 'Sesión estratégica 1:1', 'Guía con próximos pasos claros'],
  cta: {
    label: 'Quiero crear mi empresa',
    href: 'https://inkovacreation.store/shop/7f390a19-9be8-4bef-be02-00a79bcf09f8'
  }
};
const plan2: Plan = {
  id: 'plan-2',
  label: 'PLAN 2',
  name: 'Presencia Digital Profesional',
  price: '$850',
  priceNote: 'pago único · disponible en 2 pagos',
  description: 'Presenta tu negocio con una landing page profesional, clara y lista para generar confianza.',
  items: ['Landing page profesional', 'Copy estratégico', 'Diseño visual alineado a tu negocio', 'Dominio personalizado', 'Botón directo a WhatsApp y canales clave'],
  cta: {
    label: 'Quiero mi presencia digital',
    href: 'https://inkovacreation.store/shop/0a4a199b-ffee-460f-99fb-e38d1c6da17d'
  }
};
const plan3: Plan = {
  id: 'plan-3',
  label: 'PLAN 3',
  name: 'Inkova Full Creation',
  price: '$1,150',
  oldValue: 'Valor de mercado: $2,800+',
  priceNote: 'disponible en 2 pagos · no incluye fee del estado',
  description: 'Lanza tu negocio con empresa creada, presencia digital y una base profesional desde el día uno.',
  items: ['LLC registrada', 'EIN listo para operar', 'Landing page profesional de 1 página', 'Dominio personalizado', 'Email corporativo profesional', 'Llamada estratégica personalizada', 'Acompañamiento guiado en cada paso'],
  cta: {
    label: 'Quiero el Plan Full Creation',
    href: 'https://inkovacreation.store/shop/c4aa0400-b53a-4a2b-a3b1-b8dc6c49dc79'
  },
  urgency: '⚡ Últimos cupos disponibles este mes',
  highlighted: true,
  badge: 'MÁS COMPLETO'
};
function BaseCard({
  plan,
  delay
}: {
  plan: Plan;
  delay: number;
}) {
  return <motion.div id={plan.id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay,
    duration: 0.5
  }} whileHover={{
    y: -4
  }} className="flex flex-col h-full scroll-mt-24 self-center" style={{
    background: '#FFFFFF',
    border: '1.5px solid rgba(90,69,121,0.12)',
    borderRadius: '24px',
    padding: '40px 32px'
  }} data-id="element-418">
      <p style={{
      color: '#5a4579',
      fontSize: '11px',
      letterSpacing: '1.5px',
      fontWeight: 700
    }} data-id="element-419">
        {plan.label}
      </p>
      <h3 style={{
      fontSize: '22px',
      fontWeight: 800,
      color: '#2D1B4E',
      marginTop: '8px',
      lineHeight: 1.25
    }} data-id="element-420">
        {plan.name}
      </h3>

      {plan.promoBadge && <span className="inline-block self-start" style={{
      background: 'rgba(90,69,121,0.1)',
      color: '#5a4579',
      border: '1px solid rgba(90,69,121,0.2)',
      fontSize: '12px',
      fontWeight: 600,
      padding: '4px 12px',
      borderRadius: '20px',
      marginTop: '14px'
    }} data-id="element-421">
          {plan.promoBadge}
        </span>}

      <div className="flex items-baseline" style={{
      gap: '10px',
      margin: '20px 0 4px',
      flexWrap: 'wrap'
    }} data-id="element-422">
        <div style={{
        fontSize: '48px',
        fontWeight: 800,
        color: '#2D1B4E',
        lineHeight: 1.05
      }} data-id="element-423">
          {plan.price}
        </div>
        {plan.originalPrice && <div style={{
        fontSize: '20px',
        fontWeight: 600,
        color: '#9CA3AF',
        textDecoration: 'line-through',
        lineHeight: 1.05
      }} data-id="element-424">
            {plan.originalPrice}
          </div>}
      </div>
      <div style={{
      color: '#9CA3AF',
      fontSize: '13px'
    }} data-id="element-425">
        {plan.priceNote}
      </div>

      <div style={{
      height: '1px',
      background: 'rgba(90,69,121,0.12)',
      margin: '20px 0'
    }} data-id="element-426" />

      <p style={{
      color: '#6B7280',
      fontSize: '15px',
      lineHeight: 1.6,
      marginBottom: '24px'
    }} data-id="element-427">
        {plan.description}
      </p>

      <div className="flex-grow" data-id="element-428">
        <p style={{
        color: '#5a4579',
        fontSize: '11px',
        letterSpacing: '1px',
        fontWeight: 700,
        marginBottom: '12px'
      }} data-id="element-429">
          INCLUYE
        </p>
        <ul className="space-y-2.5" data-id="element-430">
          {plan.items.map((item, i) => <li key={i} className="flex items-start" style={{
          gap: '10px'
        }} data-id="element-431">
              <span className="flex items-center justify-center flex-shrink-0" style={{
            width: '18px',
            height: '18px',
            borderRadius: '50%',
            background: 'rgba(90,69,121,0.1)',
            color: '#5a4579',
            marginTop: '2px'
          }} data-id="element-432">
                <Check className="w-2.5 h-2.5" strokeWidth={3} data-id="element-433" />
              </span>
              <span style={{
            color: '#374151',
            fontSize: '14px',
            lineHeight: 1.5
          }} data-id="element-434">
                {item}
              </span>
            </li>)}
        </ul>
      </div>

      <a href={plan.cta.href} target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center gap-2 transition-all duration-300" style={{
      width: '100%',
      padding: '14px',
      border: '2px solid #5a4579',
      background: 'transparent',
      color: '#5a4579',
      borderRadius: '12px',
      fontSize: '15px',
      fontWeight: 700,
      marginTop: '32px'
    }} onMouseEnter={e => {
      const el = e.currentTarget as HTMLAnchorElement;
      el.style.background = '#5a4579';
      el.style.color = '#FFFFFF';
    }} onMouseLeave={e => {
      const el = e.currentTarget as HTMLAnchorElement;
      el.style.background = 'transparent';
      el.style.color = '#5a4579';
    }} data-id="element-435">
        <span data-id="element-436">{plan.cta.label}</span>
        <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-437" />
      </a>
    </motion.div>;
}
function HighlightedCard({
  plan,
  delay
}: {
  plan: Plan;
  delay: number;
}) {
  return <motion.div id={plan.id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay,
    duration: 0.6
  }} className="relative overflow-hidden flex flex-col h-full scroll-mt-24 lg:scale-[1.05]" style={{
    background: 'linear-gradient(160deg, #4a3666 0%, #5a4579 40%, #8B6BA8 100%)',
    border: 'none',
    borderRadius: '28px',
    padding: '48px 36px',
    boxShadow: '0 32px 80px rgba(90,69,121,0.4)'
  }} data-id="element-438">
      {/* Decorative orbs */}
      <div className="absolute pointer-events-none" style={{
      top: '-60px',
      right: '-60px',
      width: '200px',
      height: '200px',
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.05)'
    }} aria-hidden="true" data-id="element-439" />
      <div className="absolute pointer-events-none" style={{
      bottom: '-40px',
      left: '-40px',
      width: '150px',
      height: '150px',
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.04)'
    }} aria-hidden="true" data-id="element-440" />

      {/* Badge MÁS COMPLETO */}
      {plan.badge && <span className="absolute" style={{
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#FFFFFF',
      color: '#5a4579',
      fontSize: '11px',
      fontWeight: 800,
      padding: '6px 20px',
      borderRadius: '0 0 16px 16px',
      letterSpacing: '1px',
      whiteSpace: 'nowrap'
    }} data-id="element-441">
          {plan.badge}
        </span>}

      <div className="relative" data-id="element-442">
        <p style={{
        color: 'rgba(255,255,255,0.6)',
        fontSize: '11px',
        letterSpacing: '1.5px',
        fontWeight: 700,
        marginTop: '20px'
      }} data-id="element-443">
          {plan.label}
        </p>
        <h3 style={{
        color: '#FFFFFF',
        fontSize: '26px',
        fontWeight: 800,
        marginTop: '6px',
        lineHeight: 1.2
      }} data-id="element-444">
          {plan.name}
        </h3>

        {plan.promoBadge && <span className="inline-block" style={{
        background: 'rgba(255,255,255,0.15)',
        border: '1px solid rgba(255,255,255,0.25)',
        color: '#FFFFFF',
        fontSize: '12px',
        fontWeight: 600,
        padding: '4px 12px',
        borderRadius: '20px',
        margin: '12px 0'
      }} data-id="element-445">
            {plan.promoBadge}
          </span>}

        {plan.oldValue && <p style={{
        color: 'rgba(255,255,255,0.5)',
        fontSize: '12px',
        textDecoration: 'line-through',
        marginTop: '4px'
      }} data-id="element-446">
            {plan.oldValue}
          </p>}

        <div className="flex items-baseline" style={{
        gap: '12px',
        marginTop: '4px',
        flexWrap: 'wrap'
      }} data-id="element-447">
          <div style={{
          fontSize: '56px',
          fontWeight: 900,
          color: '#FFFFFF',
          lineHeight: 1.05
        }} data-id="element-448">
            {plan.price}
          </div>
          {plan.originalPrice && <div style={{
          fontSize: '22px',
          fontWeight: 600,
          color: 'rgba(255,255,255,0.5)',
          textDecoration: 'line-through',
          lineHeight: 1.05
        }} data-id="element-449">
              {plan.originalPrice}
            </div>}
        </div>
        <div style={{
        color: 'rgba(255,255,255,0.6)',
        fontSize: '13px'
      }} data-id="element-450">
          {plan.priceNote}
        </div>

        <div style={{
        height: '1px',
        background: 'rgba(255,255,255,0.15)',
        margin: '20px 0'
      }} data-id="element-451" />

        <p style={{
        color: 'rgba(255,255,255,0.8)',
        fontSize: '15px',
        lineHeight: 1.6,
        marginBottom: '24px'
      }} data-id="element-452">
          {plan.description}
        </p>

        <p style={{
        color: 'rgba(255,255,255,0.5)',
        fontSize: '11px',
        letterSpacing: '1px',
        fontWeight: 700,
        marginBottom: '12px'
      }} data-id="element-453">
          INCLUYE
        </p>
        <ul className="space-y-2.5" data-id="element-454">
          {plan.items.map((item, i) => <li key={i} className="flex items-start" style={{
          gap: '10px'
        }} data-id="element-455">
              <span className="flex items-center justify-center flex-shrink-0" style={{
            width: '18px',
            height: '18px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.15)',
            color: '#FFFFFF',
            marginTop: '2px'
          }} data-id="element-456">
                <Check className="w-2.5 h-2.5" strokeWidth={3} data-id="element-457" />
              </span>
              <span style={{
            color: '#FFFFFF',
            fontSize: '14px',
            lineHeight: 1.5
          }} data-id="element-458">
                {item}
              </span>
            </li>)}
        </ul>

        <a href={plan.cta.href} target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center gap-2 transition-all duration-300" style={{
        width: '100%',
        padding: '16px',
        background: '#FFFFFF',
        color: '#5a4579',
        borderRadius: '12px',
        fontSize: '16px',
        fontWeight: 800,
        marginTop: '32px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)'
      }} onMouseEnter={e => {
        ;
        (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(255,255,255,0.9)';
      }} onMouseLeave={e => {
        ;
        (e.currentTarget as HTMLAnchorElement).style.background = '#FFFFFF';
      }} data-id="element-459">
          <span data-id="element-460">{plan.cta.label}</span>
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-461" />
        </a>

        {plan.urgency && <p style={{
        color: 'rgba(255,255,255,0.6)',
        fontSize: '12px',
        textAlign: 'center',
        marginTop: '12px'
      }} data-id="element-462">
            {plan.urgency}
          </p>}
      </div>
    </motion.div>;
}
export function ServicesSection() {
  return <section id="planes" style={{
    background: '#FFFFFF',
    padding: '100px 0 60px'
  }} data-id="element-463">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-464">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-465">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} style={{
          color: '#5a4579',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '2px',
          textTransform: 'uppercase',
          textAlign: 'center'
        }} data-id="element-466">
            Nuestros planes
          </motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.05
        }} style={{
          fontSize: '38px',
          fontWeight: 800,
          color: '#2D1B4E',
          textAlign: 'center',
          marginTop: '8px',
          lineHeight: 1.2
        }} data-id="element-467">
            Elige el plan que más se adapta a donde estás hoy
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} style={{
          color: '#6B7280',
          fontSize: '16px',
          textAlign: 'center',
          maxWidth: '520px',
          margin: '12px auto 64px',
          lineHeight: 1.6
        }} data-id="element-468">
            Cada plan fue diseñado para una etapa específica. Sin relleno, sin
            extras que no necesitas.
          </motion.p>
        </div>

        {/* Plans grid — Plan 3 first on mobile, centered on desktop */}
        <div className="grid lg:grid-cols-3 gap-8 lg:gap-6 mb-20 items-stretch" data-id="element-469">
          {/* Plan 1: desktop col 1, mobile order 2 */}
          <div className="order-2 lg:order-1" data-id="element-470">
            <BaseCard plan={plan1} delay={0.1} data-id="element-471" />
          </div>
          {/* Plan 3: desktop col 2 (center), mobile order 1 */}
          <div className="order-1 lg:order-2" data-id="element-472">
            <HighlightedCard plan={plan3} delay={0} data-id="element-473" />
          </div>
          {/* Plan 2: desktop col 3, mobile order 3 */}
          <div className="order-3 lg:order-3" data-id="element-474">
            <BaseCard plan={plan2} delay={0.2} data-id="element-475" />
          </div>
        </div>

        {/* Add-ons compact list */}
        <div id="servicios-adicionales" className="addons-wrap" style={{
        background: 'linear-gradient(135deg, #5a4579 0%, #4a3666 100%)',
        padding: '60px 20px',
        marginLeft: 'calc(50% - 50vw)',
        marginRight: 'calc(50% - 50vw)',
        width: '100vw',
        marginTop: '48px'
      }} data-id="element-476">
          <style data-id="element-477">{`
            @media (min-width: 769px) {
              .addons-wrap { padding: 80px 40px !important; }
            }
            .addons-inner { max-width: 760px; margin: 0 auto; }
          `}</style>
          <div className="addons-inner" data-id="element-478">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-479">
              <p style={{
              color: '#5a4579',
              fontSize: '11px',
              fontWeight: 700,
              letterSpacing: '2px',
              textTransform: 'uppercase',
              textAlign: 'center',
              marginBottom: '8px'
            }} data-id="element-480">
                Servicios adicionales
              </p>
              <h3 className="text-[24px] md:text-[28px]" style={{
              color: '#FFFFFF',
              fontWeight: 800,
              textAlign: 'center',
              marginBottom: '4px',
              lineHeight: 1.2
            }} data-id="element-481">
                ¿Necesitas algo más?
              </h3>
              <p style={{
              color: 'rgba(255,255,255,0.65)',
              fontSize: '14px',
              textAlign: 'center',
              marginBottom: '32px'
            }} data-id="element-482">
                Agrega lo que necesites a tu plan actual
              </p>

              <div className="overflow-hidden" style={{
              background: 'rgba(255,255,255,0.07)',
              border: '1px solid rgba(255,255,255,0.12)',
              borderRadius: '16px'
            }} data-id="element-483">
                {([{
                icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-484">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" data-id="element-485" />
                          <polyline points="14 2 14 8 20 8" data-id="element-486" />
                          <line x1="16" y1="13" x2="8" y2="13" data-id="element-487" />
                          <line x1="16" y1="17" x2="8" y2="17" data-id="element-488" />
                          <polyline points="10 9 9 9 8 9" data-id="element-489" />
                        </svg>,
                name: 'Annual Report (Sunbiz)',
                price: '$250 / año',
                href: 'https://inkovacreation.store/shop/2daa36ca-b0f2-4795-8e34-a50134ca08da'
              }, {
                icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-490">
                          <circle cx="12" cy="12" r="10" data-id="element-491" />
                          <path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32" data-id="element-492" />
                        </svg>,
                name: 'Logo profesional',
                price: '$295',
                href: 'https://inkovacreation.store/shop/d9f43c4e-29cf-4042-88ac-baa7ae4d3c46'
              }, {
                icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-493">
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-494" />
                        </svg>,
                name: 'Notaría',
                price: '$15 – $25',
                href: 'https://wa.me/17863037695?text=Hola%2C%20quiero%20notariar%20un%20documento.%20%C2%BFQu%C3%A9%20necesito%20y%20cu%C3%A1l%20es%20el%20proceso%3F'
              }, {
                icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-495">
                          <path d="M18 20V10" data-id="element-496" />
                          <path d="M12 20V4" data-id="element-497" />
                          <path d="M6 20v-6" data-id="element-498" />
                        </svg>,
                name: 'Membresía Inkova Web Care',
                price: '$50 / mes',
                href: 'https://inkovacreation.store/shop/7d029968-338d-4b4b-a375-a84f6858d94b'
              }, {
                icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-499">
                          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" data-id="element-500" />
                          <line x1="8" y1="21" x2="16" y2="21" data-id="element-501" />
                          <line x1="12" y1="17" x2="12" y2="21" data-id="element-502" />
                        </svg>,
                name: 'Storefront: Setup de Beacons',
                price: '$295',
                href: 'https://inkovacreation.store/shop/f4a5e0ff-a84e-465d-8ce7-f3d7ebd35ffa'
              }] as const).map((row, idx, arr) => <div key={idx} className="flex items-center transition-colors" style={{
                gap: '12px',
                padding: '14px 20px',
                borderBottom: idx === arr.length - 1 ? 'none' : '1px solid rgba(255,255,255,0.08)'
              }} onMouseEnter={e => {
                ;
                (e.currentTarget as HTMLDivElement).style.background = 'rgba(255,255,255,0.05)';
              }} onMouseLeave={e => {
                ;
                (e.currentTarget as HTMLDivElement).style.background = 'transparent';
              }} data-id="element-503">
                    <div className="flex items-center justify-center flex-shrink-0" style={{
                  width: '36px',
                  height: '36px',
                  minWidth: '36px',
                  background: 'rgba(255,255,255,0.1)',
                  border: '1px solid rgba(255,255,255,0.15)',
                  borderRadius: '10px',
                  color: '#FFFFFF'
                }} data-id="element-504">
                      {row.icon}
                    </div>
                    <div className="flex-1 min-w-0 text-[14px] md:text-[15px]" style={{
                  fontWeight: 600,
                  color: '#FFFFFF'
                }} data-id="element-505">
                      {row.name}
                    </div>
                    <div style={{
                  fontSize: '14px',
                  fontWeight: 700,
                  color: '#C39BD3',
                  whiteSpace: 'nowrap',
                  marginRight: '12px'
                }} data-id="element-506">
                      {row.price}
                    </div>
                    <a href={row.href} target="_blank" rel="noopener noreferrer" className="transition-all" style={{
                  background: 'transparent',
                  border: '1.5px solid rgba(255,255,255,0.3)',
                  color: '#FFFFFF',
                  borderRadius: '8px',
                  padding: '6px 14px',
                  fontSize: '12px',
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                  cursor: 'pointer'
                }} onMouseEnter={e => {
                  const el = e.currentTarget as HTMLAnchorElement;
                  el.style.background = '#FFFFFF';
                  el.style.color = '#5a4579';
                  el.style.borderColor = '#FFFFFF';
                }} onMouseLeave={e => {
                  const el = e.currentTarget as HTMLAnchorElement;
                  el.style.background = 'transparent';
                  el.style.color = '#FFFFFF';
                  el.style.borderColor = 'rgba(255,255,255,0.3)';
                }} data-id="element-507">
                      Solicitar
                    </a>
                  </div>)}
              </div>

              {/* Mobile-only price row note: prices are hidden under sm; show price inline under name */}
              <div style={{
              textAlign: 'center',
              marginTop: '20px'
            }} data-id="element-508">
                <a href="https://wa.me/17863037695?text=Hola%2C%20quiero%20m%C3%A1s%20info%20sobre%20los%20servicios%20adicionales%20de%20Inkova." target="_blank" rel="noopener noreferrer" className="inline-flex items-center transition-all" style={{
                gap: '8px',
                background: '#25D366',
                color: '#FFFFFF',
                borderRadius: '10px',
                padding: '12px 22px',
                fontSize: '14px',
                fontWeight: 700,
                boxShadow: '0 6px 20px rgba(37,211,102,0.35)'
              }} onMouseEnter={e => {
                const el = e.currentTarget as HTMLAnchorElement;
                el.style.background = '#20BD5A';
                el.style.transform = 'translateY(-2px)';
                el.style.boxShadow = '0 10px 28px rgba(37,211,102,0.45)';
              }} onMouseLeave={e => {
                const el = e.currentTarget as HTMLAnchorElement;
                el.style.background = '#25D366';
                el.style.transform = 'translateY(0)';
                el.style.boxShadow = '0 6px 20px rgba(37,211,102,0.35)';
              }} data-id="element-509">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-510">
                    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" data-id="element-511" />
                  </svg>
                  Quiero más info · Hablar por WhatsApp
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}